<template>
  <base-modal-ex :active.sync="isActive"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="responsiveMinWidth"
    has-modal-card>
    <header class="modal-card-head">
      <p class="modal-card-title is-flex-items-center">
        <span class="mso mso-24px mr-1">car_gear</span>
        <span>Vehicle Butterfly Selector</span>
      </p>
    </header>
    <section class="modal-card-body">
      <!-- Mounted eagerly so the diagram is on screen immediately; loadSelections()
           calls hydrate() once the saved selection arrives. -->
      <vehicle-butterfly-selector ref="vehicleButterflySelector"
        v-model="selectedItems"
        sortable />
    </section>
    <footer class="modal-card-foot">
      <div style="width: 100%; display: flex; justify-content: space-between;">
        <div align="right"
          style="width: 100%">
          <button class="button tooltip"
            @click="reset"
            data-tooltip="Reset">
            <span class="icon"><i class="mdi mdi-refresh mdi-18px" /></span>
            <span>Reset</span>
          </button>
          <button class="button tooltip"
            @click="cancel"
            data-tooltip="Cancel">
            <span class="icon"><i class="mdi mdi-close mdi-18px" /></span>
            <span>Cancel</span>
          </button>
          <button class="button is-primary tooltip"
            @click="done"
            data-tooltip="Done">
            <span class="icon"><i class="mdi mdi-check mdi-18px" /></span>
            <span>Done</span>
          </button>
        </div>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'
import QuoteService from '@/views/quote/QuoteService'
import VehicleButterflySelector from './VehicleButterflySelector.vue'

export default {
  name: 'VehicleButterflyModal',
  components: {
    BaseModalEx,
    VehicleButterflySelector
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    active: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    },
    entity: { type: Object, default: () => {} }
  },
  data() {
    return {
      isActive: this.active,
      selectedItems: [...this.value],
      screenWidth: window.innerWidth
    }
  },
  computed: {
    responsiveMinWidth() {
      if (this.screenWidth < 768) {
        return 95 // Mobile
      } else if (this.screenWidth < 1024) {
        return 85 // Tablet
      } else if (this.screenWidth < 1440) {
        return 75 // Desktop
      } else {
        return 65 // Large screens
      }
    }
  },
  watch: {
    active(val) {
      this.isActive = val
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    // After mount, so the selector's ref exists and its diagram is already rendered.
    this.loadSelections()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth
    },
    async loadSelections() {
      const rows = await QuoteService.getQuoteButterfly(this.entity.quoteId)
      this.selectedItems = (rows || []).map((row) => ({
        partId: row.butterflyCode,
        partName: row.butterflyDesc,
        area: row.area,
        selected: row.isSelected,
        sortOrder: row.sortOrder
      }))
      if (this.$refs.vehicleButterflySelector) {
        this.$refs.vehicleButterflySelector.hydrate(this.selectedItems)
      }
    },
    reset() {
      // Call the reset method on the child VehicleButterflySelector component
      if (this.$refs.vehicleButterflySelector) {
        this.$refs.vehicleButterflySelector.reset()
      }
      // Clear local selectedItems as well
      this.selectedItems = []
    },
    cancel() {
      this.$emit('cancel')
      this.isActive = false
    },
    async done() {
      const items = this.selectedItems.map((item) => ({
        quoteId: this.entity.quoteId,
        area: item.area,
        butterflyCode: item.partId,
        butterflyDesc: item.partName,
        isSelected: item.selected,
        // QuoteButterfly.SortOrder is NOT NULL, and an item only gets a compacted
        // order if the user actually dragged it.
        sortOrder: item.sortOrder || 999
      }))
      await QuoteService.updateQuoteButterfly(this.entity.quoteId, items)

      this.$emit('done')
      this.isActive = false
    }
  }
}
</script>

<style scoped>
.is-flex-items-center {
  display: flex;
  align-items: center;
}
</style>